import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/pages/Login.vue'
import { createDebounce } from '../pages/tablePanels/ship/shipMethods/shipLayer'
// import Test from '@/pages/Test'


Vue.use(Router)

let _this = Vue.prototype
let routes = []

// Object.keys(config).forEach(v => {
//     let route = config[v]
//     if (Array.isArray(route.path)) {
//         route.path.forEach(v1 => {
//             routes.push({
//                 path: v1,
//                 name: v1,
//                 component: route.component

//             })
//         })
//     } else {
//         routes.push({
//             path: route.path,
//             name: route.path,
//             component: route.component
//         })
//     }
// })


let router = new Router({
    // mode: 'history',
    // routes,
    routes: [{
        path: '/',
        redirect: "/Home"
    }, {
        path: '/Home',
        name: 'Home',
        component: () =>
            import('@/pages/Home.vue'),
        meta: {
            requireLogin: true
        },
        children: [

            {
                name: "Index",
                path: "",
                component: () =>
                    import("@/pages/tablePanels/Index.vue"),
                meta: {
                    requireLogin: true
                },

            },
            {
                name: "FishResource",
                path: "FishResource",
                component: () =>
                    import("@/pages/tablePanels/FishResource.vue"),
                meta: {
                    requireLogin: true
                },

            },
            {
                name: "MixedFishResource",
                path: "MixedFishResource",
                component: () =>
                    import("@/pages/tablePanels/MixedFishResource.vue"),
                meta: {
                    requireLogin: true
                },

            },
            {
                name: "FishPrediction",
                path: "FishPrediction",
                component: () =>
                    import("@/pages/tablePanels/FishPrediction.vue"),
                meta: {
                    requireLogin: true
                },
            },
            {
                name: "ShipWorkLive",
                path: "ShipWorkLive",
                component: () =>
                    import("@/pages/tablePanels/ShipWorkLive.vue"),
                meta: {
                    requireLogin: true
                },
            },
            {
                name: "ShipWork",
                path: "ShipWork",
                component: () =>
                    import("@/pages/tablePanels/ShipWork.vue"),
                meta: {
                    requireLogin: true
                },
            },
            {
                name: "ShipWorkSleep",
                path: "ShipWorkSleep",
                component: () =>
                    import("@/pages/tablePanels/ShipWorkSleep.vue"),
                meta: {
                    requireLogin: true
                },
            },
            {
                name: "CrossBorder",
                path: "CrossBorder",
                component: () =>
                    import("@/pages/tablePanels/CrossBorder.vue"),
                meta: {
                    requireLogin: true
                },
            },
            {
                name: "fishAreaProductsFAO",
                path: "fishAreaProductsFAO",
                component: () =>
                    import("@/pages/tablePanels/FishAreaProductsFAO.vue"),
                meta: {
                    requireLogin: true
                },
            },
            {
                name: "fishAreaProductsRFMO",
                path: "fishAreaProductsRFMO",
                component: () =>
                    import("@/pages/tablePanels/FishAreaProductsRFMO.vue"),
                meta: {
                    requireLogin: true
                },
            },
            {
                name: "fishAreaProductsDownload",
                path: "fishAreaProductsDownload",
                component: () =>
                    import("@/pages/tablePanels/FishAreaProductsDownload.vue"),
                meta: {
                    requireLogin: true
                },
            },
            {
                name: "fishProject",
                path: "fishProject",
                component: () =>
                    import("@/pages/tablePanels/fishProject.vue"),
                meta: {
                    requireLogin: true
                },
            },
        ]

    }, {
        path: '/Login',
        name: 'Login',
        component: Login,
    },
    {
        path: '/wxLoading',
        name: 'WxLoading',
        component: () => import("@/pages/wxLoginComponents/WeixinLoading.vue"),
    },
    {
        path: '/excel',
        name: 'Excel',
        component: () => import("@/pages/Excel.vue"),
    },
    {
        path: '/map-test',
        name: 'MapTest',
        // component: Test,
        component: () =>
            import('@/pages/Test.vue')
    },

    ]
})
let debounce = createDebounce(2000)
router.beforeEach((to, from, next) => {
    console.log(from, to)
    if (to.meta.requireLogin) {
        // 先跳过登录
        // if (false) {
        // console.log('session', _this.$getCookie("session"))
        if (!_this.$getCookie("yzzy_web_session") || _this.$getCookie("yzzy_web_session").length == 0) {
            // _this.$message("您还未登录，不能访问页面内容")
            // 如果不是首页的redict，再显示提示信息
            if (!(from.path == "/" && to.path.toLowerCase() == "/home")) {

                debounce(() => {
                    _this.$message("您还未登录，不能访问页面内容")

                })
            }
            next({
                name: "Login"
            })
            // _this.$confirm("您还未登录，不能访问页面内容，是否去登录？", "提示", {
            //     confirmButtonText: '确定',
            //     cancelButtonText: '关闭',
            //     type: 'warning'
            // }).then(() => {
            //     next({
            //         name: "Login"
            //     })
            // }).catch(() => {
            //     window.close()
            // })

        } else {
            next()
        }
    } else {
        next()
    }
})
export default router


// WEBPACK FOOTER //
// ./src/router/index.js